import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IUIActions from "../IUIActions";
import IApp from "../../engine/IApp";
import DesktopUI from "../desktop/DesktopUI";
import DesktopUIScreen from "../desktop/DesktopUIScreen";
import AudioController from "../AudioController";
import DesktopDOM from "../desktop/DesktopDOM";

@injectable()
class VLT2UI extends DesktopUI {

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.DOM) dom: DesktopDOM,
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.UIActions) uiActions: IUIActions,
        @inject(SERVICE_IDENTIFIER.UIScreen) uiScreen: DesktopUIScreen,
        @inject(SERVICE_IDENTIFIER.AudioController) audioController: AudioController
    ) {
        super(config, app, dom, uiActions, uiScreen, audioController);
    }
}

export default VLT2UI;